import { ActionTypes } from "../constants/action-types";


const initialState = {
  agendasWithId: [],
  loading: false,
  error: null,
};

const fetchAllAgendasReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_ALL_AGENDAS_SUCCESS:
        
      return {
        ...state,
        agendasWithId: action.payload.data,
        loading: false,
        error: null,
      };
    case ActionTypes.FETCH_ALL_AGENDAS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default fetchAllAgendasReducer;
